// extracted by mini-css-extract-plugin
module.exports = {"image":"common_image__N3caU","h2":"common_h2__kI7Od","h3":"common_h3__FSguY","body":"common_body__QHCEf","list":"common_list__HMsNI"};